
import React, { Component } from "react";
import { useLocation, Route, Switch } from "react-router-dom";

import AdminNavbar from "components/Navbars/AdminNavbar";
import Footer from "components/Footer/Footer";
import Sidebar from "components/Sidebar/Sidebar";
/*! import FixedPlugin from "components/FixedPlugin/FixedPlugin.js";*/

import routes from "routes.js";

import sidebarImage from "assets/img/sidebar-n.jpg"; /*!Aqui esta la imagen que va de fondo en la Sidebar*/

function Principal() {
  const [image, setImage] = React.useState(sidebarImage);
  const [color, setColor] = React.useState("black"); /*! aqui especifica el tipo "black que se detalla en el .scss"*/
  const [hasImage, setHasImage] = React.useState("true"); /*!si esta en "true" hay imagen, sino debe ser false""*/
  const location = useLocation();
  const mainPanel = React.useRef(null);
  const getRoutes = (routes) => {
    return routes.map((prop, key) => {
      if (prop.layout === "/principal") {
        return (
          <Route
            path={prop.layout + prop.path}
            render={(props) => <prop.component {...props} />}
            key={key}
          />
        );
      } else {
        return null;
      }
    });
  };
  React.useEffect(() => {
    document.documentElement.scrollTop = 0;
    document.scrollingElement.scrollTop = 0;
    mainPanel.current.scrollTop = 0;
    if (
      window.innerWidth < 993 &&
      document.documentElement.className.indexOf("nav-open") !== -1
    ) {
      document.documentElement.classList.toggle("nav-open");
      var element = document.getElementById("bodyClick");
      element.parentNode.removeChild(element);
    }
  }, [location]);
  return (
    <>
      <div >
        <center><img src="https://www.atlas.cdmx.gob.mx/imagenes/logosgirpc.png" alt="logo"/></center>
      </div>
      <div className="wrapper">

        <Sidebar color={color} image={hasImage ? image : ""} routes={routes} />
        <div className="main-panel" ref={mainPanel}>
          <AdminNavbar />
          <div className="content">
            <Switch>{getRoutes(routes)}</Switch>
          </div>
          <Footer />
        </div>
      </div>
    </>
  );
}

export default Principal;
